define('shared/my/accessToken/get',[
    './set',
    'Promise',
    'shared/util/state',
    'shared/util/state/adapters/persistent',
    'shared/remote/efid/util',
    'shared/remote/efid/const',
    'shared/remote/queryproxy/validate',
    'shared/lib/console',
    'shared/util/promise/enclose'
], function(
    setAccessToken, 
    Promise, 
    state, 
    persistentAdapter, 
    efidUtil, 
    efidConst, 
    validate,
    console,
    enclose
){
    var MODULE_NAME = 'shared/my/accessTokenGet:';
    var retrievingPromise;

    function getAccessToken() {
        if (retrievingPromise) {
            return retrievingPromise
                .then(function(){
                    return getAccessToken();
                });
        }
        var ret = retrievingPromise = enclose(function(belt){
            return Promise.resolve()
                .then(function(){
                    return state.adapters.add(persistentAdapter);
                })
                .then(function(){
                    return state.get('persistent.accessToken');
                })
                .then(function(tokenObject){
                    var accessToken = tokenObject && tokenObject[0] && tokenObject[0].value;
                    if (accessToken) {
                        console.log(MODULE_NAME, 'Got access token from persistent store', accessToken);
                        // let's avoid checking validity of the accessToken in this case
                        // because that token was store maximumly 5 min ago
                        belt.break(accessToken);
                    }
                })
                .then(function () {
                    // get the accessToken from redirect UI 
                    // because redirect uses efid_tokens which is
                    // the same one used by platformAuth
                    // in case platformAuth
                    return efidUtil.waitForAccessToken(efidConst.CUSTOM_REDIRECT);
                })
                .then(function (data) {
                    if (data && data.access) {
                        var accessToken = data.access;
                        console.log(MODULE_NAME, 'Got access token from redirectui', accessToken);
                        return validate(accessToken)
                            .then(function(result) {
                                if (result) {
                                    return setAccessToken(accessToken)
                                        .then(function(){
                                            belt.break(accessToken);
                                        });
                                }
                            });
                    }
                });
            })
            .then(function(data){
                retrievingPromise = null;
                return data;
            }, function(err){
                retrievingPromise = null;
                Promise.reject(err);
            });

        return ret;
    }

    return getAccessToken;
});
